import { render, staticRenderFns } from "./kuspitAccountLinkingModal.vue?vue&type=template&id=d19c3bdc&"
import script from "./kuspitAccountLinkingModal.vue?vue&type=script&lang=ts&"
export * from "./kuspitAccountLinkingModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VContainer,VDialog})
